import React from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { socialData } from "../utils/socialData";
import { contactValidation } from "../utils/contactValidation";
import * as AiIcons from "react-icons/ai";
import Banner from "../components/Banner";
import Footer from "../components/Footer";

const Contact = () => {
  const [showPhone, setShowPhone] = React.useState<boolean>(true);
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        from_name: "",
        reply_to: "",
        message: "",
      },
      validationSchema: contactValidation,
      onSubmit: (values, actions) => {
        try {
          emailjs
            .send(
              "service_x2v79t8",
              "template_ah9r9k3",
              values,
              "QWd92EYTgZ7m8lCwr"
            )
            .then((result) => {
              console.log(result);
              toast.success("Message sent successfully");
              actions.resetForm();
            });
        } catch (error) {
          console.log(error);
        }
      },
    });

  const handleErrors = (e) => {
    e.preventDefault();
    if (errors.from_name && errors.reply_to && errors.message) {
      toast.error("Please fill out all fields correctly");
    } else if (errors.from_name && errors.reply_to) {
      toast.error("Please fill out your name and email correctly");
    } else if (errors.from_name && errors.message) {
      toast.error("Please fill out your name and message correctly");
    } else if (errors.reply_to && errors.message) {
      toast.error("Please fill out your email and message correctly");
    } else if (errors.from_name) {
      toast.error(errors.from_name);
    } else if (errors.reply_to) {
      toast.error(errors.reply_to);
    } else if (errors.message) {
      toast.error(errors.message);
    }
  };

  const handlePhone = (e: any) => {
    e.preventDefault();
    if (showPhone) {
      window.location.href = "tel:+12263870644";
      setShowPhone(false);
    }
  };

  return (
    <>
      <motion.div
        className="contact"
        initial={{ opacity: 0, z: 100 }}
        animate={{ opacity: 1, z: 0 }}
        exit={{ opacity: 0, z: -100 }}
        transition={{ duration: 1, delay: 0.75 }}
      >
        <div className="contact-heading">
          <Banner text="Contact" />
        </div>
        <motion.div
          className="contact-section"
          initial={{
            opacity: 0.75,
            transform: "scale(1.01)",
          }}
          whileInView={{
            opacity: 1,
            transform: "scale(1.02)",
          }}
          transition={{ duration: 0.25, delay: 0.1 }}
        >
          <div className="contact-left">
            <h2>Send a message</h2>
          </div>
          <div className="contact-right">
            <form
              onSubmit={(e) => {
                handleSubmit();
                handleErrors(e);
              }}
            >
              <div className="contact-info">
                <p>Hi, my name is</p>
                <input
                  className={
                    errors.from_name && touched.from_name ? "input-error" : ""
                  }
                  type="text"
                  name="from_name"
                  value={values.from_name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="John Doe"
                />
                <p>and you can reach me at</p>
                <input
                  className={
                    errors.reply_to && touched.reply_to ? "input-error" : ""
                  }
                  type="email"
                  name="reply_to"
                  value={values.reply_to}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="john@doe.com"
                />
                <p>I'd like to know more about</p>
                <textarea
                  className={
                    errors.message && touched.message ? "input-error" : ""
                  }
                  name="message"
                  rows={1}
                  value={values.message}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="how..."
                />
              </div>
              <div className="contact-btn-container">
                <button type="submit">
                  <span>
                    <AiIcons.AiOutlinePlus />
                  </span>{" "}
                  Send
                </button>
              </div>
            </form>
          </div>
        </motion.div>
        <motion.div
          className="contact-section"
          initial={{
            opacity: 0.75,
            transform: "scale(1.01)",
          }}
          whileInView={{
            opacity: 1,
            transform: "scale(1.02)",
          }}
          transition={{ duration: 0.25, delay: 0.1 }}
        >
          <div className="contact-left">
            <h2>Give me a ring</h2>
          </div>
          <div className="contact-right">
            <div className="contact-info">
              <span onClick={handlePhone}>
                {showPhone ? "Dial now" : "Calling..."}
              </span>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="contact-section"
          initial={{
            opacity: 0.75,
            transform: "scale(1.01)",
          }}
          whileInView={{
            opacity: 1,
            transform: "scale(1.02)",
          }}
          transition={{ duration: 0.25, delay: 0.1 }}
        >
          <div className="contact-left">
            <h2>Get social</h2>
          </div>
          <div className="contact-right">
            <div className="socials">
              {socialData.map((item, index) => (
                <a
                  key={index}
                  href={item.path}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.title}
                </a>
              ))}
            </div>
          </div>
        </motion.div>
      </motion.div>
      <Footer isContact />
    </>
  );
};

export default Contact;
